import { Upload, X } from "lucide-react";
import React, { useRef, useState } from "react";
import CustomSelect from "../../../shared/CustomSelect";
import CustomInput from "../../../shared/CustomInput";
import CustomArea from "../../../shared/CustomArea";
import Loading from "../../../shared/Loading";
import { uploadMultiImages } from "../../../sdk/upload/upload";

const AddLoanChattel = ({
  closeAddLoanChattel,
  handleAddMyChattel,
  loading,
  borrowerChattel,
  setBorrowerChattel,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    try {
      const uploadedUrls = await uploadMultiImages(files);
      setBorrowerChattel({
        ...borrowerChattel,
        images: uploadedUrls,
      });
      setSelectedFiles(files);
    } catch (err) {
      console.error("Failed to upload files:", err);
    }
  };

  const handleChooseFileClick = () => {
    fileInputRef.current.click();
  };
  return (
    <div
      onClick={(e) => {
        closeAddLoanChattel();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[530px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddLoanChattel}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[20px] right-[20px]">
          <button
            disabled={loading}
            onClick={handleAddMyChattel}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Add Chattel
          </button>
        </div>
        <div>
          <p className="text-[#000000] text-[18px] font-semibold">
            Add a Chattel
          </p>
          <p className="text-[#5C5C5C] text-[14px] font-normaal">
            Add chattel detail
          </p>
          <div className="flex items-center gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Chattel Name"
              >
                Chattel Name
              </label>
              <CustomInput
                placeholder="Enter your chattel name"
                type="text"
                value={borrowerChattel?.name}
                onChange={(e) =>
                  setBorrowerChattel({
                    ...borrowerChattel,
                    name: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Chattel Location"
              >
                Chattel Location
              </label>
              <CustomInput
                placeholder="Enter your chattel location"
                type="text"
                value={borrowerChattel?.location}
                onChange={(e) =>
                  setBorrowerChattel({
                    ...borrowerChattel,
                    location: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex items-start gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Chattel Description"
              >
                Chattel Description
              </label>
              <CustomArea
                placeholder="Enter your chattel description"
                type="text"
                value={borrowerChattel?.description}
                onChange={(e) =>
                  setBorrowerChattel({
                    ...borrowerChattel,
                    description: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Chattel Value"
              >
                Chattel Value
              </label>
              <CustomInput
                placeholder="Enter your chattel value"
                type="text"
                value={borrowerChattel?.value}
                onChange={(e) =>
                  setBorrowerChattel({
                    ...borrowerChattel,
                    value: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="flex items-center gap-[20px] my-[10px]">
            <div className="flex w-[45%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Chattel Condition"
              >
                Chattel Condition
              </label>
              <CustomSelect
                name="Chattel Condition"
                value={borrowerChattel?.condition}
                onChange={(e) =>
                  setBorrowerChattel({
                    ...borrowerChattel,
                    condition: e.target.value,
                  })
                }
                options={["New", "Old", "Good"]}
              />
            </div>
          </div>
          <div className="flex w-[45%] my-[20px] flex-col">
            <p className="text-[#222222] font-medium text-[13px]">
              Chattel Photo{" "}
              <span className="font-normal text-[#5C5C5C]">
                .jpeg or .png file only
              </span>
            </p>
            <div
              className="min-h-[90px] px-[10px] py-[12px] flex flex-col gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
              onClick={handleChooseFileClick}
            >
              {selectedFiles.length > 0 ? (
                <div className="flex flex-wrap gap-[10px]">
                  {selectedFiles.map((file, index) => (
                    <div
                      key={index}
                      className="min-w-[120px] px-[8px] py-[6px] rounded-[6px] bg-[#F9F9F9] border border-[#DDD] text-center"
                    >
                      <p className="text-[12px] font-semibold text-black truncate">
                        {file.name}
                      </p>
                      <p className="text-[11px] text-gray-500">
                        {(file.size / 1024).toFixed(2)} KB
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <Upload />
                  <p className="text-[#000000] text-[12px] font-normal">
                    Drag and Drop file here or{" "}
                    <span className="text-[#000000] underline">
                      Choose file
                    </span>{" "}
                    here
                  </p>
                </>
              )}
              <input
                type="file"
                multiple
                ref={fileInputRef}
                className="hidden"
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLoanChattel;
